import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DrawerModule } from 'primeng/drawer';
import { AssistantService } from '@/cloud/services/assistant.service';
import { TranslationService } from '@/layout/service/translation.service';
import { AssistantChatComponent } from './assistant-chat.component';

/** The assistant's side panel (cloud layout only), opened from the top bar or ⌘K. Not shown on the full-page service desk. */
@Component({
    selector: 'app-assistant-drawer',
    standalone: true,
    imports: [DrawerModule, AssistantChatComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <p-drawer
            [visible]="assistant.open() && !assistant.fullPage()"
            (visibleChange)="assistant.open.set($event)"
            position="right"
            [modal]="false"
            [blockScroll]="false"
            [style]="{ width: 'min(32rem, 100vw)' }"
            [styleClass]="assistant.docked() ? 'assistant-drawer assistant-docked' : 'assistant-drawer'"
            [ariaCloseLabel]="t()('assistant.close')"
        >
            <ng-template #headless>
                <app-assistant-chat (closed)="assistant.open.set(false)" />
            </ng-template>
        </p-drawer>
    `,
    styles: [
        `
            :host ::ng-deep .assistant-drawer {
                border-left: 1px solid var(--surface-border);
                box-shadow: -18px 0 40px -28px rgba(0, 0, 0, 0.5);
            }
            /* Docked: below the top bar, beside the page (the layout pads the page by the same width). */
            :host ::ng-deep .assistant-drawer.assistant-docked {
                top: 4rem !important;
                height: calc(100% - 4rem) !important;
                width: var(--assistant-dock-width) !important;
                box-shadow: none;
                z-index: 996 !important;
            }
            app-assistant-chat {
                display: block;
                height: 100%;
            }
        `
    ]
})
export class AssistantDrawerComponent {
    readonly assistant = inject(AssistantService);
    readonly t = inject(TranslationService).t;
}
